export default "__VITE_ASSET__f1f8d371__"